import { render, staticRenderFns } from "./AsignacionMandantePantalla.vue?vue&type=template&id=66c96918&scoped=true&"
import script from "./AsignacionMandantePantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionMandantePantalla.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionMandantePantalla.vue?vue&type=style&index=0&id=66c96918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c96918",
  null
  
)

export default component.exports